// counterSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

   export const fetchTotalPartnercm = createAsyncThunk(
   'totalPartner/fetchTotalPartnercm',
   async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
    throw new Error('Authorization token not found');
      }
      const response = await axios.post(
        'https://onboard.rechargkit.biz/home/totalMerchant',
        {}, // Empty body since dates are removed
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const totalPartnercmSlice = createSlice({
  name: 'totalPartner',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTotalPartnercm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTotalPartnercm.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTotalPartnercm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default totalPartnercmSlice.reducer;
